import { useContext, useEffect, useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper';
import css from '../carrousel.module.css';
import { ReactComponent as Arrow } from '../../../../assets/icons/arrow/Slider.svg';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

import useMediaQuery from '../../../hooks/useMediaQuery ';
import CardMarca from './CardMarca';
import { LimparToUrl } from '../../../helpers/tratarInfoCarros';
import AuthContext from '../../../hooks/AuthContext';

export default function CarrouselMarcas({ allLista, infoJson }) {
  const { state } = useContext(AuthContext);
  const ismobile = useMediaQuery('(max-width: 574px)');
  const [marcas, setMarcas] = useState([]);

  useEffect(() => {
    const allListaPorVender = allLista.filter(carro => {
      return carro.Vendido === false;
    });
    const item = allListaPorVender
      .filter(item => !['atrelados', 'pecas', 'motores'].includes(item.Viatura))
      .map(({ Marca, Viatura }) => {
        return {
          Marca,
          Viatura,
        };
      })
      .sort(function (a, b) {
        if (a.Marca.Nome < b.Marca.Nome) {
          return -1;
        }
        if (a.Marca.Nome > b.Marca.Nome) {
          return 1;
        }
        return 0;
      })
      .reduce((accum, carro) => {
        const accumulator = [...accum];
        if (!accumulator.some(item => item.Marca.Id === carro.Marca.Id && item.Marca.Nome === carro.Marca.Nome)) {
          accumulator.push(carro);
        }
        return accumulator;
      }, [])
      .map(marca => {
        const location = `${
          state.Zonas?.Layout.Carros.existe
            ? infoJson.Layout?.LandingPage?.existe
              ? '/home/usadas/'
              : '/usadas/'
            : '/viaturas/usadas/'
        }${LimparToUrl(marca.Marca.Nome)}/${
          state.Zonas?.Layout.Carros.existe ? '#listagem_viaturas' : ''
        }`;
        return {
          id: marca.Marca.Id,
          name: marca.Marca.Nome,
          viatura: marca.Viatura,
          url: location,
        };
      });

    setMarcas(infoJson.Layout.Marcas?.list?.length > 0 ? infoJson.Layout.Marcas?.list : item);
  }, [allLista, infoJson.Layout, state.Zonas?.Layout.Carros.existe]);

  const responsive = {
    0: {
      slidesPerView: 2.2,
    },
    375: {
      slidesPerView: 3.2,
    },
    574: {
      slidesPerView: 4,
    },
    767: {
      slidesPerView: 5,
    },
    991: {
      slidesPerView: 5,
    },
    1199: {
      slidesPerView: 6,
    },
    1399: {
      slidesPerView: 7,
    },
    1600: {
      slidesPerView: 8,
    },
  };

  const navigationMarcasPrevRef = useRef(null);
  const navigationMarcasNextRef = useRef(null);

  return (
    <>
      <Swiper
        className={'recentes-slider'}
        breakpoints={responsive}
        // autoplay={ismobile ? false : true}
        pagination={false}
        navigation={
          ismobile
            ? false
            : {
                prevEl: navigationMarcasPrevRef.current,
                nextEl: navigationMarcasNextRef.current,
                disabledClass: css.buttonDisable,
                lockClass: css.buttonLock,
              }
        }
        onBeforeInit={swiper => {
          swiper.params.navigation.prevEl = navigationMarcasPrevRef.current;
          swiper.params.navigation.nextEl = navigationMarcasNextRef.current;
        }}
        effect={'slide'}
        centerInsufficientSlides={true}
        centeredSlides={false}
        loop={false}
        speed={500}
        modules={[Autoplay, Pagination, Navigation]}
      >
        {marcas.map(carro => {
          return (
            <SwiperSlide key={carro.id + carro.viatura}>
              <CardMarca data={carro} infoJson={infoJson} />
            </SwiperSlide>
          );
        })}
        {ismobile ? (
          <></>
        ) : (
          <>
            <div className={`${css.buttonPrev} ${css.buttonPrevR}`} ref={navigationMarcasPrevRef}>
              <Arrow
                height="60px"
                style={{ transform: `rotate(180deg)` }}
                stroke={infoJson.Cores.ArrowSlider}
              />
            </div>
            <div className={`${css.buttonNext} ${css.buttonNextR}`} ref={navigationMarcasNextRef}>
              <Arrow height="60px" stroke={infoJson.Cores.ArrowSlider} />
            </div>
          </>
        )}
      </Swiper>
    </>
  );
}
